<template>
  <tr>
    <td data-label="Qty">{{ this.item.quantity }}</td>
    <td data-label="Title">{{ this.title }}</td>
    <td data-label="Shape">{{ this.shape }}</td>
    <td data-label="Size">
      <select v-if="sizeOptions.length" v-model="size" class="form-control" :aria-label="'Ring size for ' + title" @change="updateSize" required>
        <option v-if="!size" value="" disabled>Select size</option>
        <option v-for="option in sizeOptions" :key="option" :value="option">{{ option }}</option>
      </select>
      <span v-else>{{ this.size }}</span>
      <span v-if="sizeError" class="text-danger">{{ sizeError }}</span>
    </td>
    <td data-label="Cut">{{ this.cut }}</td>
    <td data-label="Clarity">{{ this.clarity }}</td>
    <td data-label="Colour">{{ this.colour }}</td>
    <td data-label="Polish">{{ this.polish }}</td>
    <td data-label="Symmetric">{{ this.symmetric }}</td>
    <td data-label="Unit Price">R{{ this.item.unit_price }}</td>
    <td data-label="Total">R{{ this.total }}</td>
    <td>
      <div class="btn-group" role="group" aria-label="Basic example">
        <button v-if="this.quantity > 1 && this.quantity !== 1" type="button" class="btn btn-sm btn-primary" @click="decrementItem">
          <i class="fa fa-chevron-down"></i>
        </button>
        <button v-if="this.item.moissanite_id" type="button" class="btn btn-sm btn-secondary" @click="incrementItem">
          <i class="fa fa-chevron-up"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger" @click="removeItem">
          <i class="fa fa-trash-o"></i>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>

export default {
  name: 'item',
  props: {
    item: Object,
  },
  data() {
    return {
      title: null,
      shape: null,
      size: null,
      sizeOptions: [],
      sizeError: null,
      cut: null,
      clarity: null,
      colour: null,
      polish: null,
      symmetric: null,
      quantity: this.item.quantity,
      unit_price: this.item.unit_price,
      total: 0.00,
    }
  },
  created() {
    this.calculateTotal();
    if (this.item.diamond_id) {
      this.getDiamondInfo();
    }

    if (this.item.piece_id) {
      this.getPieceInfo();
    }

    if (this.item.lab_grown_diamond_id) {
      this.getLabGrownDiamondInfo();
    }

    if (this.item.moissanite_id) {
      this.getMoissaniteInfo();
    }
  },
  methods: {
    getDiamondInfo() {
      this.axios.get("/api/cart/" + this.item.diamond_id + "/diamond").then((response) => {
        if (response.status === 200) {
          this.title = response.data.title;
          this.shape = response.data.shape;
          this.size = response.data.size;
          this.cut = response.data.cut;
          this.clarity = response.data.clarity;
          this.colour = response.data.colour;
          this.polish = response.data.polish;
          this.symmetric = response.data.symmetric;
        }
      })
    },
    getLabGrownDiamondInfo() {
      this.axios.get("/api/cart/" + this.item.lab_grown_diamond_id + "/lab_grown_diamond").then((response) => {
        if (response.status === 200) {
          this.title = response.data.title;
          this.shape = response.data.shape;
          this.size = response.data.size;
          this.cut = response.data.cut;
          this.clarity = response.data.clarity;
          this.colour = response.data.colour;
          this.polish = response.data.polish;
          this.symmetric = response.data.symmetric;
        }
      })
    },
    getMoissaniteInfo() {
      this.axios.get("/api/cart/" + this.item.moissanite_id + "/moissanite").then((response) => {
        if (response.status === 200) {
          this.title = response.data.title;
          this.shape = response.data.shape;
          this.size = response.data.size;
          this.cut = response.data.cut;
          this.clarity = response.data.clarity;
          this.colour = response.data.colour;
          this.polish = response.data.polish;
          this.symmetric = response.data.symmetric;
        }
      })
    },
    getPieceInfo() {
      this.axios.get("/api/cart/" + this.item.piece_id + "/piece").then((response) => {
        if (response.status === 200) {
          this.title = response.data.title;
          this.size = this.item.size || response.data.total_diamonds;
          this.sizeOptions = response.data.size_options;
        }
      })
    },
    updateSize() {
      this.sizeError = null;
      this.axios.patch('/api/cart/items/' + this.item.id + '/size', {size: this.size}).then((response) => {
        this.size = response.data.size;
        this.item.size = response.data.size;
      }).catch((error) => {
        this.size = this.item.size;
        this.sizeError = error.response?.data?.size?.join(', ') || 'Unable to update size';
      });
    },
    decrementItem() {
      this.$emit("item-decrement", this.item.id);
      this.quantity--;
      this.calculateTotal();
    },
    incrementItem() {
      this.$emit("item-increment", this.item.id);
      this.quantity++;
      this.calculateTotal();
    },
    removeItem() {
      this.$emit("item-deleted", this.item.id);
    },
    calculateTotal() {
      this.total = (this.quantity * this.unit_price).toFixed(2);
    },
  },
}
</script>

